<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectStyleOverride-1">
<p class="CHAPTER1" id="uw6Nu8jevx7WBsCbljxQK8G"><a id="uVvEjGbeHfIXt2tDEa86cTH"></a>Preface</p>
<p class="FIRSTPARAGRAPH">In late April 2019, and only days after my fourth book in my series of books on Ted Bundy was published, a Facebook friend by the name of Michael Rinehart, contacted me with a most curious question: had I thought about writing an encyclopedia on the Ted Bundy murder case, and I told him no. Indeed, the thought of it was so currently out of the realm of reality for me, that there just wasn’t any way I’d consider it. But I did thank him for the suggestion, and we both agreed that it was right to set the idea aside for the time being. Truth be told, Michael had considered doing it himself. But he’s so busy with current projects – with others in the pipeline waiting for him –, that it was only natural he’d think of me. A great idea, we both agreed, and we let it drop right there.</p>
<p class="Normal _idGenParaOverride-1">However, over the next several days, every time our conversation crossed my mind, I had this unmistakable good feeling about the project, and so after about three days, I decided to contact my publisher and run the idea by them. And immediately, they loved the idea. Well, that response, coupled with my “good feelings” has allowed me to take the step that’s led me to write the Encyclopedia of the Ted Bundy Murders. It is, without question, the go-to guide into all things Ted Bundy, the innocent victims who fell by his hands, and the hundreds of people and dozens of locations that became intertwined, and sometimes synonymous with, the life and times of Ted Bundy. For those desiring to know the thousands of interconnected facts of the case, and what has transpired with all those involved over the years, this is the book for you.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Preface.vue?eb6a6670